import { GET } from '@/admin-shared-modules/utils/ajax'
import _ from 'lodash'

import parentStore from '../magazine-recommend.store'

class Store {
  state = {
    visible: true,
    list: {
      items: [],
      index: 1,
      size: 20,
      total: 0,
      loading: false
    },
    search: {
      data: {
        fid: null,
        key_word: ''
      }
    },

    cate: []
  }

  async fetch(reset = false) {
    if (reset) this.state.list.index = 1
    this.state.list.loading = true
    this.state.list.items = []
    try {
      const res = await GET('qikan', {
        data: {
          lib_type: parentStore.state.list.tagGroup.currentId,
          pageIndex: this.state.list.index - 1,
          pageSize: 10,
          ..._.omitBy(this.state.search.data, v => !v)
        }
      })
      this.state.list.items = res.data.items
      this.state.list.total = res.data.totalCount
    } catch (e) {
      console.error(e)
    } finally {
      this.state.list.loading = false
    }
  }

  async fetchCate() {
    const res = await GET('qikan/categorys', {
      data: {
        lib_type: parentStore.state.list.tagGroup.currentId
      }
    })
    this.state.cate = res.data
  }
}

export default new Store()
